"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var le5le_store_1 = require("le5le-store");

var canvas_1 = require("./canvas");

var Offscreen =
/** @class */
function (_super) {
  __extends(Offscreen, _super);

  function Offscreen(parentElem, options) {
    if (options === void 0) {
      options = {};
    }

    var _this = _super.call(this, parentElem, options) || this;

    _this.parentElem = parentElem;
    _this.options = options;
    _this.activeLayer = le5le_store_1.Store.get('LT:ActiveLayer');
    _this.hoverLayer = le5le_store_1.Store.get('LT:HoverLayer');
    _this.animateLayer = le5le_store_1.Store.get('LT:AnimateLayer');
    le5le_store_1.Store.set('LT:offscreen', _this.canvas);
    return _this;
  }

  Offscreen.prototype.render = function () {
    _super.prototype.render.call(this);

    var ctx = this.canvas.getContext('2d');
    ctx.strokeStyle = this.options.color;
    this.renderNodes();
    this.renderLines();
    this.activeLayer.render(ctx);
    this.animateLayer.render(ctx);
    this.hoverLayer.render(ctx);
  };

  Offscreen.prototype.renderNodes = function () {
    if (!this.data.nodes.length) {
      return;
    }

    var ctx = this.canvas.getContext('2d');

    for (var _i = 0, _a = this.data.nodes; _i < _a.length; _i++) {
      var item = _a[_i];
      item.render(ctx);
    }
  };

  Offscreen.prototype.renderLines = function () {
    if (!this.data.lines.length) {
      return;
    }

    var ctx = this.canvas.getContext('2d');
    var i = 0;

    for (var _i = 0, _a = this.data.lines; _i < _a.length; _i++) {
      var item = _a[_i];

      if (!item.to) {
        this.data.lines.splice(i++, 1);
        continue;
      }

      item.render(ctx);
      ++i;
    }
  };

  return Offscreen;
}(canvas_1.Canvas);

exports.Offscreen = Offscreen;